function isAuthInCache() {
	return (sessionStorage.getItem('loggedIn') || '').toLowerCase() === 'true';
}


export class AuthError {
	message: string = '';
	counter: number = 0;

	add(newMessage: string) {
		this.message = newMessage;
		this.counter += 1;
	}
}

export enum SSOState {
	Init,
	Checking,
	CheckingError,
	NeedAuth,
	Auth,
	Signout,
	SignoutProcess,
	SignoutError,
	Redirect,
}

export class Auth {
	private _isAuth: boolean = false;

	private _token: string | null = null;

	private _dms3Hash: string | null = null;

	private _jmeno: string | null = null;

	private _prijmeni: string | null = null;

	public resetPassword = false;
	public changePassword = false;

	/**
	 * SSO state.
	 */
	_ssoState: SSOState;

	constructor() {
		this._isAuth = false;
		this._token = null;
		this._jmeno = null;
		this._prijmeni = null;
		this._ssoState = SSOState.Init;
		this.error = { message: '', counter: 0, add(message) { this.message = message; this.counter += 1; } };
	}

	get ssoState() {
		return this._ssoState;
	}

	set ssoState(state) {
		this._ssoState = state;
	}

	error = new AuthError();

	get isAuth() {
		return this._isAuth || isAuthInCache();
	}

	set auth(val: boolean) {
		sessionStorage.setItem('loggedIn', val.toString());
		this._isAuth = val;
	}

	get token() {
		return this._token;
	}

	set token(val) {
		this._token = val;
	}

	get dms3Hash() {
		return this._dms3Hash;
	}

	set dms3Hash(val) {
		this._dms3Hash = val;
	}

	init() {
		this._isAuth = isAuthInCache();
	}

	logout() {
		this._isAuth = false;
		sessionStorage.setItem('loggedIn', 'false');
	}

	get Jmeno() { return this._jmeno; }

	set Jmeno(val) { this._jmeno = val; }

	get Prijmeni() { return this._prijmeni; }

	set Prijmeni(val) { this._prijmeni = val; }
}

export const state = new Auth();
